export default __webpack_public_path__ + "static/media/logo_dextools.25fb968a.png";